import React from "react";
import { Link } from "react-router-dom";
import SsoLoginCallBack from "Utils/SsoLoginCallBack";



const SsoCallBackGoogle = () => {
    SsoLoginCallBack("google");
    return(
        <>
        </>
    )
}

export default SsoCallBackGoogle;